/* eslint-disable no-use-before-define */
import { ajax, arrayFrom, setConfig, parseDate } from '../twd/twd'


export const getUserHoldings = async () => {
    let {data} = ajax({
        url: '/esb/retailservice/holdingAndAlertDataService/getUserHoldings',
        method: 'GET'
    })

    let rs = await data
    setUserHoldings(rs)
}

export const setUserHoldings = (rs) => {
    let accts = arrayFrom(rs.accounts)
        .filter(a => a.title && a.title.trim())
        .filter(({maturity}) => {
            const isMatured = parseDate(maturity) < Date.now()
            return !isMatured
        })

    setConfig({
        holdings: arrayFrom(rs.holdings),
        accounts: accts,
        cusips_held: arrayFrom(rs.holdings).reduce((x,h) => {
            let cusip = h.cusip
            if (!cusip) return x
            if (!x[cusip]) x[cusip] = []
            x[cusip].push(h)

            return x
        }, {}),
        holdings_ts: Date.now()
    })
}